import { Component, computed, inject, input, output, ChangeDetectionStrategy } from "@angular/core";
import { MatCard } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import { TranslocoPipe } from "@jsverse/transloco";
import dayjs from "dayjs";
import { LorenAsset } from "../../../loren-assets/interfaces/loren-asset.interface";
import { LOREN_ROUTES } from "../../../../shared/constants/loren-routes.constants";
import { LorenDateModule } from "../../../../shared/pipes/loren-date/loren-date.module";
import { MatAnchor, MatButton } from "@angular/material/button";
import { AsyncPipe } from "@angular/common";
import { toObservable } from "@angular/core/rxjs-interop";
import { withLatestFrom } from "rxjs";
import { AssetGroupService } from "../../../asset/asset-group.service";
import { map } from "rxjs/operators";
import { getAssetLocation } from "../../../asset/asset.utils";

@Component({
  imports: [
    MatCard,
    MatIcon,
    TranslocoPipe,
    LorenDateModule,
    MatAnchor,
    AsyncPipe,
    MatButton
],
  selector: "loren-map-details-popup",
  styleUrl: "./loren-map-details-popup.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loren-map-details-popup.component.html"
})
export class LorenMapDetailsPopupComponent {
  private router = inject(Router);

  asset = input.required<LorenAsset>();
  location = computed(() => getAssetLocation(this.asset()));
  private readonly asset$ = toObservable(this.asset);
  private readonly assetGroupService = inject(AssetGroupService);
  protected readonly groupsNames$ = this.asset$.pipe(
    withLatestFrom(this.assetGroupService.all),
    map(([asset, groups]) => {
      return groups.filter(x => asset.belongsToGroups.includes(x.id))
    }),
    map(groups => groups.map(x => x.name))
  )

  closed = output()

  assetUpdated = computed(() => this.calculateLastUpdateForAsset(this.asset()));

  navigateToAsset() {
    this.router.navigateByUrl(`${LOREN_ROUTES.ASSET}/${this.asset().id}`);
  }

  private calculateLastUpdateForAsset(asset: LorenAsset) {
    if (asset.updatedOn) {
      return asset.updatedOn;
    }
    return asset.metering
      .map((metering) => dayjs(metering.time))
      .reduce((latest, current) => {
        return current.isBefore(latest) ? current : latest;
      })
      .format();
  }
}
